import io from "socket.io-client";

export default io(process.env.VUE_APP_WS, {
  path: "/sqws",
  autoConnect: false,
});
